function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ReceiveTemplate = require('./receive.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var SaitoUser = require('./../../saito-user/saito-user');
var Receive = /*#__PURE__*/function () {
  function Receive(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, Receive);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
    this.overlay.clickBackdropToClose = false;
    this.counter_party = new SaitoUser(this.app, this.mod, '#receive-crypto-request-container .counterparty-details');
    this.app.connection.on('saito-crypto-receive-render-request', function (details) {
      _this.render(details);
    });
    this.app.connection.on('saito-crypto-receive-confirm', function (details) {
      _this.updateOverlay(details);
    });
  }

  /**
   * Shows a confirmation overlay before initiating a crypto transfer
   * @param ticker { string } - name of a currency
   * @param amount { string } - the amount of crypto
   * @param publicKey { string } - Saito public key of recipient
   * @param address { string } - address of receiver (for currency)
   * @param trusted { boolean } - flag for whether to autoprocess
   * @param mycallback { function} - to run when approved
   *
   */
  return _createClass(Receive, [{
    key: "render",
    value: function render(details) {
      var _this2 = this;
      //
      // Verify complete information
      //
      if (!(details !== null && details !== void 0 && details.ticker) || !(details !== null && details !== void 0 && details.amount)) {
        console.error('Missing ticker/amount in Receive Crypto Overlay');
        return;
      }
      if (!(details !== null && details !== void 0 && details.publicKey) || !(details !== null && details !== void 0 && details.address)) {
        console.error('Missing address in Receive Crypto Overlay');
        return;
      }
      console.log('Show overlay');
      this.overlay.show(ReceiveTemplate(this.app, this.mod, details), function () {
        console.log('&&&&&&&&&&& close overlay -- run call back!!!');
        if (details.mycallback) {
          details.mycallback();
        }
      });
      this.counter_party.publicKey = details.publicKey;
      this.counter_party.render();
      var html = "\n\t\t\t<div class=\"profile-public-key\">\n\t\t\t\t".concat(details.address.slice(0, 8), "...").concat(details.address.slice(-8), "\n            </div>");
      this.counter_party.updateUserline(html);
      this.attachEvents();
      if (details !== null && details !== void 0 && details.trusted) {
        console.log('Trusted!');
        this.timeout = setTimeout(function () {
          _this2.overlay.close();
          _this2.timeout = null;
        }, 3000);
        this.countDown();
      }
    }
  }, {
    key: "countDown",
    value: function countDown() {
      var _this3 = this;
      // Countdown clock
      setTimeout(function () {
        var c = document.querySelector('#receive-crypto-request-container .crypto-transfer-countdown span');
        if (c) {
          var value = parseInt(c.innerHTML);
          value = Math.max(value - 1, 0);
          c.innerHTML = value.toString();
          _this3.countDown();
        }
      }, 900);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this4 = this;
      if (document.getElementById('crypto_receipt_btn')) {
        document.getElementById('crypto_receipt_btn').onclick = function (e) {
          var ignoreBtn = document.querySelector('#ignore_checkbox');
          if (ignoreBtn !== null && ignoreBtn !== void 0 && ignoreBtn.checked) {
            _this4.mod.saveGamePreference('crypto_transfers_inbound_trusted', 1);
          }
          _this4.overlay.close();
        };
      }
    }
  }, {
    key: "updateOverlay",
    value: function updateOverlay(results) {
      var _this5 = this;
      var success = (results === null || results === void 0 ? void 0 : results.hash) && !(results !== null && results !== void 0 && results.err);
      if (document.getElementById('receive-crypto-request-container')) {
        document.querySelector('.spinner').style.display = 'none';
        if (success) {
          document.querySelector('#auth_title').innerHTML = "Received Payment";
          document.querySelector('#game-crypto-icon').style.display = 'block';
        } else {
          document.querySelector('#auth_title').innerHTML = "Failure";
          document.querySelector('#game-crypto-failure-icon').style.display = 'block';
        }
        if (this.timeout) {
          clearTimeout(this.timeout);
          setTimeout(function () {
            _this5.overlay.close();
            _this5.timeout = null;
          }, 3000);
          document.querySelector('#receive-crypto-request-container .crypto-transfer-countdown span');
        }
      }
    }
  }]);
}();
module.exports = Receive;